import * as React from 'react';
const MenuIcon = ({ color, size }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 459 459", "aria-labelledby": "menu" },
        React.createElement("g", null,
            React.createElement("g", { id: "menu" },
                React.createElement("path", { fill: color, d: "M0,382.5h459v-51H0V382.5z M0,255h459v-51H0V255z M0,76.5v51h459v-51H0z" })))));
};
export default MenuIcon;
//# sourceMappingURL=MenuIcon.js.map